<template>
    <div class="statement-block">
        <div class="statement-item">
            <div class="statement-item-icon loader"></div>
            <div class="statement-info">
                <div class="statement-description"><div class="description-loader"></div></div>
                <div class="statement-category"><div class="category-loader"></div></div>
            </div>
            <div class="statement-amount">
                <div class="amount-loader"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    //
}
</script>

<style scoped lang="scss">
@keyframes placeHolderShimmer{
    0%{
        background-position: -468px 0
    }
    100%{
        background-position: 468px 0
    }
}

.statement-block-date {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    text-align: center;

    color: rgba(37, 42, 50, 0.5);
}

.statement-amount {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    color: #252A32;

    &.income {
        color: #58CC97;
    }

    b {
        font-style: normal;
        font-weight: normal;
        font-size: 18px;

        display: flex;
        align-items: center;
        text-align: right;
    }

    .currency {
        font-size: 11px;
        margin-bottom: -5px;
        margin-left: 3px;
    }
}

.statement-block {
    width: 100%;

    .statement-block-header {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 30px 0 20px;

        .statement-block-date {
            margin-left: auto;
        }
    }

    .statement-item {
        border-left: 2px solid #dddddd;

        width: 100%;

        display: flex;
        align-items: center;
        margin: 20px 0;

        .statement-item-icon {
            font-style: normal;
            font-weight: bold;
            font-size: 19px;
            display: flex;
            text-align: center;
            align-items: center;
            justify-content: center;
            margin-left: 10px;

            width: 48px;
            height: 48px;
            border-radius: 50%;

            box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);

            &.loader {
                animation-duration: 4.9s;
                animation-fill-mode: forwards;
                animation-iteration-count: infinite;
                animation-name: placeHolderShimmer;
                animation-timing-function: linear;
                background: #fcfdff;
                background: linear-gradient(to right, #eeeeee 10%, #dddddd 18%, #eeeeee 33%);
                background-size: 48px * 5 100%;
                position: relative;
            }
        }

        .statement-info {
            margin-left: 15px;

            .statement-description {
                font-style: normal;
                font-weight: 500;
                font-size: 18px;

                color: #252A32;

                .description-loader {
                    height: 23px;
                    width: 200px;

                    animation-duration: 1.9s;
                    animation-fill-mode: forwards;
                    animation-iteration-count: infinite;
                    animation-name: placeHolderShimmer;
                    animation-timing-function: linear;
                    background: #fcfdff;
                    background: linear-gradient(to right, #eeeeee 10%, #dddddd 18%, #eeeeee 33%);
                    background-size: 200px * 5 100%;
                    position: relative;
                }
            }
            
            .statement-category {
                font-style: normal;
                font-weight: normal;
                font-size: 14px;

                color: rgba(37, 42, 50, 0.5);

                .category-loader {
                    height: 18px;
                    width: 100px;
                    margin-top: 4px;

                    animation-duration: 3.6s;
                    animation-fill-mode: forwards;
                    animation-iteration-count: infinite;
                    animation-name: placeHolderShimmer;
                    animation-timing-function: linear;
                    background: #fcfdff;
                    background: linear-gradient(to right, #eeeeee 10%, #dddddd 18%, #eeeeee 33%);
                    background-size: 100px * 5 100%;
                    position: relative;
                }
            }
        }

        .statement-amount {
            display: flex;
            align-items: center;
            margin-left: auto;
            color: #252A32;

            .amount-loader {
                height: 23px;
                width: 100px;

                animation-duration: 2.6s;
                animation-fill-mode: forwards;
                animation-iteration-count: infinite;
                animation-name: placeHolderShimmer;
                animation-timing-function: linear;
                background: #fcfdff;
                background: linear-gradient(to right, #eeeeee 10%, #dddddd 18%, #eeeeee 33%);
                background-size: 100px * 5 100%;
                position: relative;
            }
        }

        .remove-btn {
            margin-left: 20px;
            position: relative;
            margin-right: -60px;
            opacity: 0;
            transition: 0.3s;
        }

        &.clicked {
            .remove-btn {
                margin-right: 0;
                opacity: 1;
            }
        }

        &.income {
            .statement-amount {
                color: #58CC97;
            }
        }
    }
}
</style>